import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({

    dateStyle: {
        color: '#fff'
    },
    currencyBold:{
        fontWeight: 'bold',
        color: 'white'
    }
});
